window.WebComponent('mobile-nav-bar', {
  props: ['visibility'],

  connected() {
    this.isMenuOpen = false;
    this.bind();
  },

  methods: {
    onVisibility(_, value) {},

    bind() {
      // bind events
      setTimeout(() => this.bindEvents(), 100)
    },

    bindEvents() {
      const $megamenu = this.$megamenu = document.querySelector('mega-menu');
      const { $el } = this;
      const [$search, $cart, $megamenuTrigger, $closeMenu] = $el.querySelectorAll('.mnb__button--search, .mnb__button--cart, .mnb__button--megamenu, .mnb__button--closemenu')

      // in-memory cache
      Object.assign(this, { $search, $cart, $megamenuTrigger, $closeMenu })

      $megamenuTrigger.addEventListener('click', () => {
        const { megamenuTarget } = $megamenuTrigger.dataset
        $megamenu.$context.toggle(megamenuTarget)

        this.isMenuOpen = true;

        this.onMenuVisibilityChange()
      });

      $closeMenu.addEventListener('click', () => {
        $megamenu.$context.toggle()
        this.isMenuOpen = false;
        this.onMenuVisibilityChange()
      })

      $search.addEventListener('click', () => document.querySelector('.js-search-header')?.click())
      $cart.addEventListener('click', (e) => {
        e.stopPropagation()
        document.querySelector('.js-drawer-open-cart')?.click()
      })

      window.addEventListener('@menu-change', (e) => {
        const { isopen } = e.details
        this.onMenuVisibilityChange(isopen)
      })
    },

    onMenuVisibilityChange(isOpen) {
      const { $megamenuTrigger, $closeMenu } = this
      const isMenuOpen = isOpen ?? this.isMenuOpen
      if(isMenuOpen) {
        $megamenuTrigger.classList.add('--hide')
        $closeMenu.classList.remove('--hide')
      } else {
        $megamenuTrigger.classList.remove('--hide')
        $closeMenu.classList.add('--hide')
      }
    }
  },
});
